import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  batchId: string;
  lrns: string[];
}

export const useSendDeclarationsByLrn = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, lrns = [] }: HookProps) => {
      const result = await apiClient.declarationsCustoms.resendDeclarationsWithSameLrn.mutation({
        params: { batchId },
        body: { lrns },
      });
      if (result.status !== 200) throw result.body;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declarations'] });
      queryClient.invalidateQueries({ queryKey: ['declaration-groups'] });
      toast.success('Started sending all declarations!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending all declarations!`);
    },
  });
};
